import { Button } from '@mui/material';
import React from 'react';
import { Alert, AlertProps } from './Alert';

import { ModalActions } from './ModalActions';

export class ConfirmationDialog extends Alert<
  { onConfirm: () => void } & AlertProps
> {
  Actions: React.FC<any> = () => {
    const { onConfirm, onClose } = this.props;
    return (
      <ModalActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm}>
          Confirm
        </Button>
      </ModalActions>
    );
  };
}
